import {Component} from '@angular/core';
import {QueryService} from '@pt/api-client';
import {IoniconsOutline, UiWidget, WidgetConfiguration} from '@pt/pt-models';
import {ActionsSubject, Store} from '@ngrx/store';
import {AbstractWidgetDirective} from '../../abstract-widget.directive';
import {
  WidgetPreliminaryRiskAssessmentCheckedValueV0,
  WidgetPreliminaryRiskAssessmentPreviewV0
} from './models/widget-preliminary-risk-assessment-preview-v0';
import {WidgetPreliminaryRiskAssessmentV0Utils} from './widget-preliminary-risk-assessment-v0.utils';
import {WidgetPreliminaryRiskAssessmentValueV0} from './models/widget-preliminary-risk-assessment-value-v0';
import {WidgetPreliminaryRiskAssessmentPropertiesV0} from './models/widget-preliminary-risk-assessmant-properties-v0';
import {TranslateService} from '@ngx-translate/core';
import {WidgetDialogService} from '../../../services/widget-dialog.service';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-widget-preliminary-risk-assessment-v0',
  template: `
    <div class='position-relative' *ngIf="internalStatus.enabled">

      <pt-widget-disabled
        *ngIf='internalStatus.isDisabled'
        [showLoader]="internalStatus.viewMode === 'LOADING'">
      </pt-widget-disabled>

      <pt-widget-header
        class='w-100'
        [label]='widget?.label'
        [help]='widget?.help'

        [comment]="comment"
        [unsavedComment]="unsavedComment"
        [showCancelButton]='internalStatus.showCancelButton'
        [showCommentButton]='internalStatus.showCommentButton'
        [showEditButton]='internalStatus.showEditButton'
        [showReloadButton]='internalStatus.showReloadButton'
        [showSaveButton]='internalStatus.showSaveButton'
        [showOptButton]='internalStatus.showOptButton'

        [disabledCancelButton]='internalStatus.disabledCancelButton'
        [disabledCommentButton]='internalStatus.disabledCommentButton'
        [disabledEditButton]='internalStatus.disabledEditButton'
        [disabledOptButton]='internalStatus.disabledOptButton'
        [disabledReloadButton]='internalStatus.disabledReloadButton'
        [disabledSaveButton]='internalStatus.disabledSaveButton'
        [loading]='internalStatus.isLoading'

        (clickSaveWidget)='saveWidget(false)'
        (clickResetWidget)='resetWidget(widget)'
        (clickEditWidget)='dispatchEditState()'
        (clickReloadWidget)='reloadWidget(widget)'
        (clickCreateOpt)='createOptWidget()'
        (clickCommentWidget)='clickCommentWidget()'>
      </pt-widget-header>

      <ng-container *ngIf='!internalStatus.showOptButton'>

        <pt-widget-preliminary-risk-assessment-v0-table
          [noDataLabel]="noDataLabel"
          *ngIf='editorData'
          [ngClass]="{'d-none' : internalStatus.viewMode !== 'EDIT' }"
          [valutations]='editorData'
          [preview]='false'
          (changeValutations)='changeValutations($event)'>
        </pt-widget-preliminary-risk-assessment-v0-table>


        <pt-widget-preliminary-risk-assessment-v0-table
          [noDataLabel]="noDataLabel"
          *ngIf="internalStatus.viewMode === 'PREVIEW' && previewData"
          [preview]='true'
          [valutations]='previewData'>
        </pt-widget-preliminary-risk-assessment-v0-table>

        <pt-widget-error
          *ngIf="internalStatus.viewMode === 'ERROR'"
          [errorMessage]='internalStatus.errorMessage | async'>
        </pt-widget-error>

      </ng-container>
    </div>
  `
})
export class WidgetPreliminaryRiskAssessmentV0Component extends AbstractWidgetDirective<WidgetPreliminaryRiskAssessmentPreviewV0[]> {

  queryResponseElement = 0;
  editorData: WidgetPreliminaryRiskAssessmentPreviewV0[]; // non è il previewValue ma è il valore attuale, modificato durante l'edit mode
  IconCheck = IoniconsOutline.check;

  constructor(public store: Store,
              public actionsSubject: ActionsSubject,
              public translateService: TranslateService,
              public widgetDialogService: WidgetDialogService,
              public service: QueryService,
              public permissionService: NgxPermissionsService) {
    super(store, actionsSubject, translateService, widgetDialogService, permissionService);
  }

  loadWidget(widget: UiWidget): void {
    this.dispatchInitState();

    this.service.resolve(widget?.args?.query).subscribe(
      (queryResponse: unknown[]) => {
        this.queryResponseElement = queryResponse?.length;
        const mapping = widget.args.query.mapping;
        const wProp: WidgetPreliminaryRiskAssessmentPropertiesV0 = widget.properties ? widget.properties as WidgetPreliminaryRiskAssessmentPropertiesV0 : {};
        this.editorData = WidgetPreliminaryRiskAssessmentV0Utils.queryResponseToValutationRow(queryResponse, mapping, widget.value);
        this.processProperties(wProp);
        this.valueController(widget, this.editorData);
        this.checkValidity();
        this.dispatchCompleteState(this.editorData);
      }, () => {
        this.dispatchErrorState();
      }
    );
  }

  saveWidget(ignoreTrigger?: boolean): void {
    const widget = JSON.parse(JSON.stringify(this.widget)) as UiWidget;
    widget.value = this.editorData?.filter((r) => r.checked !== WidgetPreliminaryRiskAssessmentCheckedValueV0.NONE)
      .map((r: WidgetPreliminaryRiskAssessmentPreviewV0) => {
        return {
          uuid: r.uuid,
          selected: r.checked === WidgetPreliminaryRiskAssessmentCheckedValueV0.TRUE,
          editable: r.editable !== null && r.editable !== undefined ? r.editable : true
        } as WidgetPreliminaryRiskAssessmentValueV0;
      });
    widget.comment = this.comment;
    this.checkValidity();
    this.completeSaveWidget(widget, ignoreTrigger);
  }

  changeValutations(valutation: WidgetPreliminaryRiskAssessmentPreviewV0[]) {
    this.editorData = valutation;
    this.checkValidity();
  }

  configuration(): WidgetConfiguration {
    return {supportAutoSave: false, supportValidation: false};
  }

  private processProperties(properties: WidgetPreliminaryRiskAssessmentPropertiesV0) {
    if (properties) {

      // ho impostato lo switch perchè mi aspetto più case
      switch (true) {
        case properties?.uuidDisabled && properties?.uuidDisabled.length > 0 :

          this.editorData?.forEach((row: WidgetPreliminaryRiskAssessmentPreviewV0) => {
            row.disabled = properties.uuidDisabled.includes(row.uuid);
          });
          break;
      }
    }
  }

  private checkValidity() {
    switch (true) {
      case this.widget?.opt:
        this.isValid$.next(true);
        break;

      case !this.queryResponseElement:
        // console.warn('[PRELIMINARY RISK ASSESSMENT] Missing query response ' + this.queryResponseElement);
        this.isValid$.next(false);
        break;

      case !this.editorData:
        // console.warn('[PRELIMINARY RISK ASSESSMENT] Missing current value');
        this.isValid$.next(false);
        break;

      case !!this.editorData?.find((r) => r.checked === WidgetPreliminaryRiskAssessmentCheckedValueV0.NONE):
        // console.warn('[PRELIMINARY RISK ASSESSMENT] Find NONE value');
        // console.warn(this.editorData?.find((r) => r.checked === WidgetPreliminaryRiskAssessmentCheckedValueV0.NONE));
        this.isValid$.next(false);
        break;

      case this.queryResponseElement !== this.editorData.length:
          this.isValid$.next(false);
          break;

      default:
        this.isValid$.next(true);
    }
  }

  private valueController(widget: UiWidget, data: WidgetPreliminaryRiskAssessmentPreviewV0[]) {
    const noData = !data || data?.length === 0;
    if (noData) {
      this.sendWidgetNotificationInvalidQueryResponseNoData(data);
    }

    const widgetValue: WidgetPreliminaryRiskAssessmentValueV0[] = widget?.value ? widget?.value : [];
    const validValue = WidgetPreliminaryRiskAssessmentV0Utils.getValidValue(widgetValue, data);
    if (validValue?.length !== widgetValue?.length) {
      const updatedWidget = JSON.parse(JSON.stringify(widget));
      updatedWidget.value = validValue;
      this.sendWidgetNotificationInvalidQueryResponseInvalidValue(updatedWidget);
    }
  }
}




